import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import ProgressWidgetSkeleton from './ProgressWidgetSkeleton'

const ProgressWidgetPlaceholder = () => {
  return (
    <ProgressWidgetSkeleton
      headerSection={<LoadingBox width="80px">&nbsp;</LoadingBox>}
      contentSection={
        <LoadingBox width="100%" height="200px" borderRadius="1x">
          &nbsp;
        </LoadingBox>
      }
    />
  )
}

export default ProgressWidgetPlaceholder
